import ErrorBoundary from "@Components/ErrorBoundary";
import FullPageLoader from "@Components/FullPageLoader";
import { loadPaymentSuccessData } from "@Pages/BookForm/data/loadPaymentSuccessData";
import { AppState } from "@Store/index";
import loadable from "@loadable/component";
import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import AmberCopilotWrapper from "@Components/Chatbot/AmberCopilotWrapper";
import wrapperHOC from "@Utils/wrapperHOC";

const NotFound = loadable(() => import("@Pages/NotFound"), {
  fallback: <FullPageLoader />,
});

const PaymentSuccess = loadable(() => import("./PaymentSuccessWrapper"), {
  fallback: <FullPageLoader />,
});

const PaymentComplete = (props: any) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { paymentTokenData } = useSelector(
    ({ bookFormData }: AppState) => ({
      paymentTokenData: bookFormData.paymentTokenData,
    }),
    shallowEqual,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadPaymentSuccessData(props));
  }, []);

  if (paymentTokenData.err) {
    return <NotFound {...props} />;
  }

  if (paymentTokenData.token !== queryParams.get("token")) {
    return <FullPageLoader />;
  }

  return (
    <ErrorBoundary>
      <PaymentSuccess {...props} />
      <AmberCopilotWrapper />
    </ErrorBoundary>
  );
};

export default wrapperHOC(PaymentComplete, {
  componentName: "PaymentComplete-PaymentSuccess",
  showForChina: true,
});
